import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from '../services';
import KartyaTipusForm from './KartyaTipusForm';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import moment from 'moment';
import RFForm from '../../../components/Form/RFForm';
import TimeFormatter from '../../../commons/TimeFormatter';

class KartyaTipusContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      
      // DATA
      baseJson: [],
      viewObj: {},
      currentId: undefined,
      torlesId: undefined,

      // FORM
      formNev: '',
      formKod: '',
      formAzonositoGen: false,
      formPrefix: '',
      formSablon: null,
      formKiegeszito: '',
      formDarabszam: '',
      formPartnercsoport: null,
      formCsoport: null,
      formSzuletesnap: null,
      formTelefonszam: null,
      formEmail: null,
      formErvenyessegKezdete: null,
      formErvenyessegVege: null,
      formErvenyessegVegeTipus: null,
      formVegeTol: '',
      formAlapAr: '',
      formCsereAr: '',
      formCsere: false,
      formErvenyesitheto: false,
      formFizetesimodkotelezo: false,
      formHelyiArak: [],

      //FORM HELYSZIN
      currentHelyId: null,
      showHelyiAr: false,
      modalHelyiArForm: false,
      formHelyszin: null,
      formPenznem: null,
      formHelyiAlapAr: '',
      formHelyiCsereAr: '',
      formHelyiKezdete: null,
      formHelyiVege: null,


      // MODAL UTILS
      formTypeStatus: false,
      modalView: false,
      modalDelete: false,
      modalForm: false,
      modalHelyszinForm: false,
      modalHelyszinDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if(this.props.active !== prevProps.active){
      if(this.props.active){
        this.listKartyaTipus();
      }
    }
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleHelyiArModal = () => {
    this.setState(prevState => ({ showHelyiAr: !prevState.showHelyiAr }));
  }

  toggleHelyiArForm = () => {
    this.setState(prevState => ({ modalHelyiArForm: !prevState.modalHelyiArForm }));
  }

  toggleHelyiArDeleteModal = () => {
    this.setState(prevState => ({ modalHelyszinDelete: !prevState.modalHelyszinDelete }));
  }

  // KÁRTYATÍPUS REQUESTS

  listKartyaTipus = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listKartyaTipus(false, (err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  getKartyaTipusView = (id) => {
    this.setState({
      viewStatus: 'LOAD',
    }, () => {
      Services.viewKartyaTipus(id, (err, res) => {
        if (!err) {
          this.setState({
            viewObj: res[0],
            viewStatus: 'DATA',
          });
        } else {
          this.setState({
            viewStatus: 'NETW'
          });
        }
      });
    });
  }

  getKartyaTipusForm = (id) => {
    this.setState({
      formStatus: 'LOAD',
    }, () => {
      Services.getKartyaTipus(id, (err, res) => {
        if (!err) {
          this.setState({
            formStatus: 'DATA',
            formNev: res[0].nev,
            formKod: res[0].azonosito,
            formAzonositoGen: res[0].azonositoGen,
            formPrefix: res[0].prefix,
            formSablon: this.hasValue(res[0].sablonId) ? {id: res[0].sablonId, nev: 'Alapértelmezett sablon'}: null,
            formKiegeszito: res[0].kiegeszito,
            formDarabszam: res[0].darabszam,
            formPartnercsoport: res[0].partnercsoport,
            formCsoport: res[0].csoport,
            formSzuletesnap: res[0].szuletesnap,
            formTelefonszam: res[0].telefon,
            formEmail: res[0].email,
            formErvenyessegKezdete: res[0].ervenyessegKezdete,
            formErvenyessegVege: res[0].ervenyessegVege,
            formErvenyessegVegeTipus: res[0].ervenyessegVegeTipus,
            formVegeTol: res[0].vegetolNap,
            formAlapAr: res[0].alapAr,
            formCsereAr: res[0].csereAr,
            formCsere: res[0].csere,
            formErvenyesitheto: res[0].ervenyesitheto,
            formFizetesimodkotelezo: res[0].fizetesimodkotelezo,
            formHelyiArak: res[0].helyiArak,
            showHelyiAr: res[0].helyiArak && res[0].helyiArak.length > 0
          }, () => {
          });
        } else {
          this.setState({
            formStatus: 'NETW'
          });
        }
      });
    });
  }

  hasValue = (value) => {
    return value || value === 0;
  }

  saveKartyaTipus = (formValues) => {
    const {
      currentId,
      formTypeStatus,
      formNev,
      formKod,
      formAzonositoGen,
      formPrefix,
      formSablon,
      formKiegeszito,
      formDarabszam,
      formPartnercsoport,
      formCsoport,
      formSzuletesnap,
      formTelefonszam,
      formEmail,
      formErvenyessegKezdete,
      formErvenyessegVege,
      formErvenyessegVegeTipus,
      formVegeTol,
      formAlapAr,
      formCsereAr,
      formCsere,
      formErvenyesitheto,
      formFizetesimodkotelezo,
      formHelyiArak
    } = this.state;

    let helyiArak = [];    
    formHelyiArak.forEach(x => {
      helyiArak.push(
        { 
          id: !x.new ? x.id : null,
          helyszin: x.helyszin,
          penznem: x.penznem,
          alapAr: x.alapAr, 
          csereAr: x.csereAr,
          kezdete: x.kezdete ? TimeFormatter.formatIso( x.kezdete ) : null,
          vege: x.vege ? TimeFormatter.formatIso( x.vege ) : null,
        }
      );
    });
    
    this.setState({
      saveButtonLoading: true
    }, () => {
      if (formTypeStatus == 'FEL') {
        let submitObj = {};

        submitObj.azonosito = formKod;
        submitObj.nev = formNev;
        submitObj.azonositoGen = !!formAzonositoGen;
        submitObj.prefix = formPrefix;
        submitObj.sablonId = formSablon && formSablon.id;
        submitObj.kiegeszito = formKiegeszito;
        submitObj.darabszam = formDarabszam;
        submitObj.partnercsoportId = formPartnercsoport && formPartnercsoport.id;
        submitObj.csoport = formCsoport && formCsoport.name;
        submitObj.szuletesnap = formSzuletesnap && formSzuletesnap.name;
        submitObj.telefon = formTelefonszam && formTelefonszam.name;
        submitObj.email = formEmail && formEmail.name;
        submitObj.ervenyessegKezdete = formErvenyessegKezdete && formErvenyessegKezdete.name;
        submitObj.ervenyessegVege = formErvenyessegVege && formErvenyessegVege.name;
        submitObj.ervenyessegVegeTipus = formErvenyessegVegeTipus && formErvenyessegVegeTipus.name;
        submitObj.vegetolNap = formVegeTol;
        submitObj.alapAr = formAlapAr;
        submitObj.csereAr = formCsereAr;
        submitObj.csere = !!formCsere;
        submitObj.ervenyesitheto = !!formErvenyesitheto;
        submitObj.fizetesimodkotelezo = !!formFizetesimodkotelezo;
        submitObj.helyiArak = helyiArak;

        Services.addKartyaTipus(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Vásárlói kártyatípus felvéve!');
            this.toggleFormModal();
            this.listKartyaTipus();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      } else if(formTypeStatus == 'MOD') {
        let submitObj = {};

        submitObj.id = currentId;
        submitObj.azonosito = formKod;
        submitObj.nev = formNev;
        submitObj.azonositoGen = !!formAzonositoGen;
        submitObj.prefix = formPrefix;
        submitObj.sablonId = formSablon && formSablon.id;
        submitObj.kiegeszito = formKiegeszito;
        submitObj.darabszam = formDarabszam;
        submitObj.partnercsoportId = formPartnercsoport && formPartnercsoport.id;
        submitObj.csoport = formCsoport && formCsoport.name;
        submitObj.szuletesnap = formSzuletesnap && formSzuletesnap.name;
        submitObj.telefon = formTelefonszam && formTelefonszam.name;
        submitObj.email = formEmail && formEmail.name;
        submitObj.ervenyessegKezdete = formErvenyessegKezdete && formErvenyessegKezdete.name;
        submitObj.ervenyessegVege = formErvenyessegVege && formErvenyessegVege.name;
        submitObj.ervenyessegVegeTipus = formErvenyessegVegeTipus && formErvenyessegVegeTipus.name;
        submitObj.vegetolNap = formVegeTol;
        submitObj.alapAr = formAlapAr;
        submitObj.csereAr = formCsereAr;
        submitObj.csere = !!formCsere;
        submitObj.ervenyesitheto = !!formErvenyesitheto;
        submitObj.fizetesimodkotelezo = !!formFizetesimodkotelezo;
        submitObj.helyiArak = helyiArak;

        Services.editKartyaTipus(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Vásárlói kártyatípus módosítva!');
            this.toggleFormModal();
            this.listKartyaTipus();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
    });
  }


  deleteKartyaTipus = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteKartyaTipus(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listKartyaTipus();
        this.props.globals.addSuccess('Vásárlói kártyatípus törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  // KÁRTYATÍPUS EVENTS

  handleNewClick = () => {
    const tulajdonosDefault = {name: "NEM_JELENIK", caption: "Nem jelenik meg"};
    const datumDefault = {name: "KEZI", caption: "Kézi megadás"};
    const vegeTipusDefault = {name: "AKT", caption: "Aktuális időpont"};
    const csoportDefault = {name: "PARTNER_VALASZTHATO", caption: "Partner választható"};

    this.setState({
      currentId: null,
      formStatus: 'DATA',
      formTypeStatus: 'FEL',
      formKod: '',
      formNev: '',
      formAzonositoGen: false,
      formPrefix: '',
      formSablon: null,
      formKiegeszito: '',
      formDarabszam: '',
      formPartnercsoport: null,
      formCsoport: csoportDefault,
      formSzuletesnap: tulajdonosDefault,
      formTelefonszam: tulajdonosDefault,
      formEmail: tulajdonosDefault,
      formErvenyessegKezdete: datumDefault,
      formErvenyessegVege: datumDefault,
      formErvenyessegVegeTipus: vegeTipusDefault,
      formVegeTol: '',
      formAlapAr: '',
      formCsereAr: '',
      formCsere: false,
      formErvenyesitheto: false,
      formFizetesimodkotelezo: false,
      formHelyiArak:[], 
    }, () => this.toggleFormModal());
  }

  handleEditClick = (id) => {
    this.setState({
      formTypeStatus: 'MOD',
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getKartyaTipusForm(id);
      this.toggleFormModal();
    });
  }

  handleViewClick = (id) => {
    this.setState({
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getKartyaTipusView(id, false);
      this.toggleViewModal();
    });
  }

  handleDeleteClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  // HELYIÁR EVENTS

  uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  }

  handleNewHelyiAr = () => {
    this.setState({
      currentHelyId: null,
      formHelyszin: null,
      formPenznem: null,
      formHelyiAlapAr: '',
      formHelyiCsereAr: '',
      formHelyiKezdete: null,
      formHelyiVege: null,
    }, () => {
      this.toggleHelyiArForm();
    });
  }


  groupBy = (arr, key) => {
    return arr.reduce((acc, c) => {
      (acc[c[key]] = acc[c[key]] || []).push(c);
      return acc;
    }, {});
  }

  handleAddHelyiAr = () => {
    const {
      currentHelyId, 
      formHelyiArak,
      formHelyszin,
      formPenznem,
      formHelyiAlapAr,
      formHelyiCsereAr,
      formHelyiKezdete,
      formHelyiVege,
    } = this.state;

    if (!formHelyiKezdete) {
      this.props.globals.addError('Érvényesség kezdetének megadása kötelező!');
      return;
    }

    if (formHelyiArak.filter(helyiAr => helyiAr.id != currentHelyId && !helyiAr.new && helyiAr.helyszin?.id == formHelyszin?.id).some(helyiAr => new Date(formHelyiKezdete) <= new Date(helyiAr.kezdete))) {
      this.props.globals.addError('Új ár a helyszínen csak az előző ár kezdeténél későbbi érvényességgel rögzíthető!');
      return;
    }

    if (formHelyiKezdete < new Date()) {
      this.props.globals.addError('Érvényesség kezdete nem lehet múltbeli időpont!');
      return;
    }

    if ((formHelyiAlapAr || formHelyiCsereAr) && !formPenznem) {
      this.props.globals.addError('Pénznem megadása kötelező ár megadása esetén!');
      return;
    }

    if(formHelyiArak.length > 0){
      let addedHelyszinArray = [];
      formHelyiArak.forEach(x => {
        if(x.id != currentHelyId){
          addedHelyszinArray = [...addedHelyszinArray, ...x.helyszinek || []];
        }
      });
      /*const found = addedHelyszinArray.filter(x => !x.vege).map(x => x.id).some(x=> formHelyszinArray.map(y => y.id).indexOf(x) >= 0)
      if(found) {
        this.props.globals.addWarning('Csak egy új helyszín ár hozzáadása lehetséges!');
        return;
      }*/
    }

    if(currentHelyId){
      const edited = {...formHelyiArak.find(x => x.id == currentHelyId)};
      const idx = formHelyiArak.findIndex(x => x.id == currentHelyId);
      edited.helyszin = formHelyszin;
      edited.penznem = formPenznem;
      edited.alapAr = formHelyiAlapAr;
      edited.csereAr = formHelyiCsereAr;
      edited.kezdete = formHelyiKezdete;
      edited.vege = formHelyiVege;
      formHelyiArak.splice(idx, 1, edited);
      this.setState({
        formHelyiArak
      }, () => {
        this.toggleHelyiArForm();
      });
    }else{
      let newValue = {
        id: this.uuidv4(),
        new: true,
        helyszin: formHelyszin,
        penznem: formPenznem,
        alapAr: formHelyiAlapAr,
        csereAr: formHelyiCsereAr,
        kezdete: formHelyiKezdete,
        vege: formHelyiVege
      };

      formHelyiArak.push(newValue);
      this.setState({
        formHelyiArak
      }, () => {
        this.toggleHelyiArForm();
      });
    }
  }

  handleEditHelyiArClick = (row) => {
    if (isNaN(row.id)) {
      this.handleEditHelyiArClickSetState(row);
      return;
    }
    Services.checkKartyaTipusArDeleteEdit(row.id, true, (err) => {
      if (!err) {
        if (row.vege) {
          this.props.globals.addError('Nem a legutolsó ár a helyszínen, ezért nem módosítható!');
          return;
        }
        this.handleEditHelyiArClickSetState(row);
      }
    });
  }

  handleEditHelyiArClickSetState = (row) => {
    this.setState({
      currentHelyId: row.id,
      formPenznem: row.penznem,
      formHelyszin: row.helyszin?.id == null ? null : row.helyszin,
      formHelyiAlapAr: row.alapAr,
      formHelyiCsereAr: row.csereAr,
      formHelyiKezdete: row.kezdete,
      formHelyiVege: row.vege,
    }, () => {
      this.toggleHelyiArForm();
    });
  }

  handleDeleteHelyiArClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleHelyiArDeleteModal();
    });
  }

  deleteKartyaTipusHelyszin = () => {
    const {
      torlesId,
      formHelyiArak
    } = this.state;

    if (!formHelyiArak.find(x => x.id == torlesId)?.new) {
      this.setState({ deleteButtonLoading: true }, () => {
        Services.checkKartyaTipusArDeleteEdit(torlesId, false, (err) => {
          if (!err) {
            this.setState({
              formHelyiArak: formHelyiArak.filter( x => x.id != torlesId),
            }, () => {
              this.toggleHelyiArDeleteModal();
            });
          }
          this.setState({ deleteButtonLoading: false });
        });
      });
    } else {
      this.setState({ formHelyiArak: formHelyiArak.filter( x => x.id != torlesId) });
      this.toggleHelyiArDeleteModal();
    }
  }


  // INPUT EVENTS

  handleInputChange = (e, v) => {
    const { target } = e;
    const value = v || (target.type === 'checkbox' ? target.checked : target.value);
    const { name } = target;
    
    this.setState({
      [name]: value
    });
  }

  handleSelectInputChange = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment> 
          <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekint'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekint'} delay={50}>
            {'Megtekintés'}
          </UncontrolledTooltip>
        </React.Fragment> 
        {this.props.globals.hasRole(['KEDVEZMENY_VKTIPUS'], true) && (
          <React.Fragment>

            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>

            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderView = () => {
    const {
      viewObj
    } = this.state;

    return (
      <div>
        <h6>Vásárlói kártyatípus:</h6>
        <b>Név: </b>
        {viewObj && viewObj.nev}
        <br />
        <b>Azonositó: </b>
        {viewObj && viewObj.azonosito}
      </div>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'azonosito',
        text: 'Azonositó',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];
    
    return (
        <div className="animated fadeIn">
          <BootstrapTable
            bootstrap4
            keyField="id"
            data={this.state.baseJson}
            columns={columns}
            filter={filterFactory()}
            pagination={paginationFactory(Lib.bootstraptableProps)}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </div>
    );
  }

  renderTableView = () => {
    return(
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.listKartyaTipus()}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
    );
  }

  renderModals = () => {
    const helyszinAr = {
      showHelyiAr: this.state.showHelyiAr,
      modalHelyiArForm: this.state.modalHelyiArForm,
      toggleHelyiArForm: this.toggleHelyiArForm,
      toggleHelyiAr: this.toggleHelyiArModal,
      handleAddHelyiAr: this.handleAddHelyiAr,
      handleEditHelyiArClick: this.handleEditHelyiArClick,
      handleDeleteHelyiArClick: this.handleDeleteHelyiArClick,
      handleNewHelyiAr: this.handleNewHelyiAr,
      formHelyszin: this.state.formHelyszin,
      formPenznem: this.state.formPenznem,
      formHelyiAlapAr: this.state.formHelyiAlapAr,
      formHelyiCsereAr: this.state.formHelyiCsereAr,
      formHelyiKezdete: this.state.formHelyiKezdete,
      formHelyiVege: this.state.formHelyiVege,
    };
    return(
      <React.Fragment>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteKartyaTipus()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalHelyszinDelete} toggle={this.toggleHelyiArDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteKartyaTipusHelyszin()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleHelyiArDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static">
          <ModalHeader>
            {'Megtekintés'}
          </ModalHeader>
          <ModalBody>
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getKartyaTipusView(this.state.currentId)}
              />),
              DATA: (this.renderView())
            }[this.state.viewStatus]}
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="lg">
          <RFForm
            modal
            onSubmit={this.saveKartyaTipus}
            title={this.state.formTypeStatus == 'FEL' ? 'Vásárlói kártyatípus rögzítése': 'Vásárlói kártyatípus módosítása'}
            footer={
              <>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={this.state.saveButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleFormModal}>Mégsem</Button>
              </>
            }
          >
            {{
              LOAD: (
                <Loader />
              ),
              NETW: (
                <NetworkEmptyState
                  hasImage
                  submitClick={() => this.getKartyaTipusForm(this.state.currentId)}
                />),
              DATA: 
                <KartyaTipusForm 
                  modositas={!!this.state.currentId}
                  formNev={this.state.formNev}
                  formKod={this.state.formKod}
                  formAzonositoGen={this.state.formAzonositoGen}
                  formPrefix={this.state.formPrefix}
                  formSablon={this.state.formSablon}
                  formKiegeszito={this.state.formKiegeszito}
                  formDarabszam={this.state.formDarabszam}
                  formPartnercsoport={this.state.formPartnercsoport}
                  formCsoport={this.state.formCsoport}
                  formSzuletesnap={this.state.formSzuletesnap}
                  formTelefonszam={this.state.formTelefonszam}
                  formEmail={this.state.formEmail}
                  formErvenyessegKezdete={this.state.formErvenyessegKezdete}
                  formErvenyessegVege={this.state.formErvenyessegVege}
                  formErvenyessegVegeTipus={this.state.formErvenyessegVegeTipus}
                  formVegeTol={this.state.formVegeTol}
                  formAlapAr={this.state.formAlapAr}
                  formCsereAr={this.state.formCsereAr}
                  formErvenyesitheto={this.state.formErvenyesitheto}
                  formFizetesimodkotelezo={this.state.formFizetesimodkotelezo}
                  formCsere={this.state.formCsere}
                  formHelyiArak={this.state.formHelyiArak}
                  helyszinAr={helyszinAr}
                  handleInputChange={this.handleInputChange}
                  handleSelectInputChange={this.handleSelectInputChange}
                  handleDateInputChange={this.handleDateInputChange}
                />
            }[this.state.formStatus]}
          </RFForm>
        </Modal>
    </React.Fragment>
    );
  }

  render = () => {
    return (
      <React.Fragment>
        <div className="row" style={{ marginTop: 22 }}>
          <div className="col-md-12">
            {this.props.globals.hasRole(['KEDVEZMENY_VKTIPUS'], true) && (
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                {'Új vásárlói kártyatípus'}
              </Button>
            )}
          </div>
          {this.renderTableView()}
        </div>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

KartyaTipusContent.propTypes = {
  globals: PropTypes.object
};

export default KartyaTipusContent;
